import yup from 'yup';
import { getSetting, getCsrfToken } from '../../utils.js';

export async function validateInput(schema, field, value) {
  return await yup.reach(schema, field).validate(value);
}

export async function validateAtInput(schema, field, object) {
  return await schema.validateAt(field, object);
}

export async function validateForm(schema, object) {
  return await schema.validate(object, { abortEarly: false });
}

export async function submit(url, method, jsonData) {
  let localPrefix = 'http://localhost:8000';
  if (window.location.host === 'localhost:5000') {
    url = `${localPrefix}${url}`;
  }
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const jwt = getSetting('jwt');
  if (jwt) {
    headers['Authorization'] = `JWT ${jwt}`;
  } else {
    headers['X-CSRFToken'] = getCsrfToken();
  }
  const setting = {
    method: method,
    headers,
    body: JSON.stringify(jsonData),
  };

  const response = await fetch(url, setting);

  let data = {};

  try {
    data = await response.json();
  } catch (err) {}

  if (!response.ok) {
    throw data;
  }

  return data;
}

// This will upload the file after having read it
export async function upload(url, file) {
  let localPrefix = 'http://localhost:8000';
  if (window.location.host === 'localhost:5000') {
    url = `${localPrefix}${url}`;
  }

  const headers = {};

  const jwt = getSetting('jwt');
  if (jwt) {
    headers['Authorization'] = `JWT ${jwt}`;
  } else {
    headers['X-CSRFToken'] = getCsrfToken();
  }
  const response = await fetch(url, {
    // Your POST endpoint
    method: 'POST',
    headers: headers,
    body: file, // This is your file object
  });

  let data = {};

  try {
    data = await response.json();
  } catch (err) {}

  if (!response.ok) {
    throw data;
  }

  return data;
}
